import { useNavigationStore } from "~/stores/navigationStore";

export function useAuth() {
  const router = useRouter();

  const navigationStore = useNavigationStore();

  function login({ sessionToken }: { sessionToken: string }) {
    localStorage.setItem("sessionToken", sessionToken);
    router.push("/");
  }

  function logout() {
    localStorage.removeItem("sessionToken");
    navigationStore.activeAdvertiser = null;
    router.push("/login");
  }

  return {
    getSessionToken: () => localStorage.getItem("sessionToken"),
    login,
    logout,
  };
}
